import React, { useState } from "react";
import Container from "../components/Layout/Container";
import AutosysRules from "../components/Autosys/AutosysRules";
import SystemRules from "../components/Autosys/SystemRules";

export default function AutosysScreen({ match }) {
  const [tabId, setTabId] = useState("autosys_rules");

  const renderTabContent = () => {
    switch (tabId) {
      case "autosys_rules":
        return <AutosysRules tabId={tabId} setTabId={setTabId} />;
      case "system_rules":
        return <SystemRules tabId={tabId} setTabId={setTabId} />;
      default:
        return null;
    }
  };

  const getLocation = () => {
    switch (tabId) {
      case "autosys_rules":
        return {
          locationName: "Autosys",
          locationUrl: match.url,
        };
      case "system_rules":
        return {
          locationName: "System rules",
          locationUrl: match.url,
        };
      default:
        return {
          locationName: "Autosys",
          locationUrl: match.url,
        };
    }
  };

  return (
    <Container location={getLocation()}>
      {renderTabContent()}
    </Container>
  );
}
